import API from "../API";
import { getGuestTokenParams } from "../../token/token";

export const getCouponApi = async (payload) => {
  try {
    const response = await API.put(
      `/ecommerce/get/coupon?id=${payload?.id || 0}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const ApplyCouponApi = async (payload) => {
  try {
    const response = await API.post(
      `/ecommerce/apply/coupon?code=${payload?.code || ""}`,
      payload,
      { params: getGuestTokenParams() },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
